import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/axios'
import './plugins/element'
import './permission'

import 'overlayscrollbars/css/OverlayScrollbars.css'
import { OverlayScrollbarsComponent } from 'overlayscrollbars-vue'
Vue.component('overlay-scrollbars', OverlayScrollbarsComponent)

// FIX: 引入DOMPurify并注册全局过滤器
import DOMPurify from 'dompurify'
Vue.filter('sanitize', (value) => {
  if (!value) return ''
  return DOMPurify.sanitize(value)
})
// 注册全局方法
Vue.prototype.$sanitize = DOMPurify.sanitize

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
